export let ErrorViewType;

(function (ErrorViewType) {
  ErrorViewType["Offline"] = "Offline";
  ErrorViewType["Custom"] = "Custom";
  ErrorViewType["Generic"] = "Generic";
  ErrorViewType["Unknown"] = "Unknown";
})(ErrorViewType || (ErrorViewType = {})); // extensible but hardly used